export default __webpack_public_path__ + "static/media/reliable-icon.508cfa37.svg";